export { httpClientCustomer } from './http-client-customer'
